
const TIPO_POLIZA = (state, tipos_polizas) => {
    state.tipos_polizas = tipos_polizas;
};

const TIPO_CUENTA_CONTABLE = (state, tipo_cuenta_contable) => {
    state.tipo_cuenta_contable = tipo_cuenta_contable;
};

const CUENTA_CONTABLE = (state, cuenta_contable) => {
    state.cuenta_contable = cuenta_contable;
};

const CUENTAS_CONTABLES = (state, cuentas_contables) => {
    state.cuentas_contables = cuentas_contables;
};

const EJERCICIOS = (state, ejercicios) => {
    state.ejercicios = ejercicios;
};

export default {
    TIPO_POLIZA,
    TIPO_CUENTA_CONTABLE,
    CUENTA_CONTABLE,
    CUENTAS_CONTABLES,
    EJERCICIOS,
};
